@for (item of items; track $index; let last = $last) {
<i class="inline-flex _star"
   [class.m-r-1]="!last"
   [class._empty]="item >= this.maxHalf"
   [class._half]="item < this.maxHalf && item >= this.maxFull"
   [class._full]="item < this.maxFull"></i>
}